import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  IconButton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  FaMoneyCheckAlt,
  FaCheckCircle,
  FaTimesCircle,
} from "react-icons/fa";
import { motion } from "framer-motion";
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import PersonRemoveAlt1Icon from '@mui/icons-material/PersonRemoveAlt1';


const HRBPExpensesReportScreen = () => {
  const navigate = useNavigate();

  const reportData = [
    {
      number: "01",
      label: "Employes Salary Reports",
      path: "/EmployeeSalaryReports",
      icon: <FaMoneyCheckAlt size={26} />,
      color: "#1E88E5",
    },
    {
      number: "02",
      label: "Expenses Reports",
    //   path: "/EmployeeSalaryReports",
      icon: <FaMoneyCheckAlt size={26} />,
      color: "#8E24AA",
    },
    // {
    //   number: "02",
    //   label: "Employes Present Reports",
    //   path: "/EmployeePresentReports",
    //   icon: <PersonAddAlt1Icon size={26} />,
    //   color: "#00ACC1",
    // },
    // {
    //   number: "03",
    //   label: "Employes Absent Reports",
    //   path: "/EmployeeAbsentReports",
    //   icon: <PersonRemoveAlt1Icon size={26} />,
    //   color: "#8E24AA",
    // },
  ];

  // Animation variants for framer-motion
  const cardVariant = {
    hidden: { opacity: 0, y: 50 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.2,
        duration: 0.6,
        type: "spring",
        stiffness: 80,
      },
    }),
  };

  return (
    <Box sx={{ mt: "5%", mr: "1%", ml: "1%" }}>
      {/* Header */}
      <Box display="flex" alignItems="center" sx={{ mb: 2 }}>
        <IconButton onClick={() => navigate(-1)} sx={{ color: "black", mr: 1 }}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h4" fontWeight="bold">
          Human Resource Basic Payroll Report
        </Typography>
      </Box>

      {/* Main Card */}
      <Card
        sx={{
          borderRadius: 3,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          backgroundColor: "white",
          minHeight: "500px",
          padding: "20px",
          width: "95%",
          mx: "auto",
            display: "flex",             // Add these
            alignItems: "center",        // Center vertically
            justifyContent: "center",
        }}
      >
       <CardContent 
       sx={{
          width: "100%",
          padding: 0,
        }}
        >
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      flexWrap: "wrap",
      gap: 4, // adds space between the card containers
      padding: 2,
    }}
  >
    {reportData.map((item, idx) => (
      <motion.div
        key={idx}
        custom={idx}
        variants={cardVariant}
        initial="hidden"
        animate="visible"
        style={{ perspective: "1000px" }}
      >
        <Box
          onClick={() => navigate(item.path)}
          sx={{
            position: "relative",
            width: 240, // slightly wider card
            padding: "24px 16px",
            borderRadius: "20px",
            backgroundColor: "#f4f5f7",
            // boxShadow: "0 6px 68px rgba(0, 0, 0, 0.1)", 
              boxShadow: `
                      4px 4px 12px rgba(0, 0, 0, 0.2),     /* right + bottom */
                      0 4px 6px rgba(0, 0, 0, 0.1)          /* soft shadow */
                    `,
            cursor: "pointer",
            transition: "transform 0.4s ease, box-shadow 0.4s ease",
            textAlign: "center",
            "&:hover": {
              transform: "translateY(-6px) rotateY(4deg) rotateX(2deg)",
             boxShadow: `
                        6px 8px 24px rgba(0, 0, 0, 0.25),    /* enhanced right + bottom */
                        0 4px 16px rgba(0, 0, 0, 0.12)
                      `,
            },
          }}
        >
         
          {/* Side Accent */}
                          <Box
                                                    sx={{
                                                      position: "absolute",
                                                      top: 0,
                                                      bottom: 0,
                                                      left: -8, // <-- changed from right
                                                      width: "8px",
                                                      borderTopLeftRadius: "12px",
                                                      borderBottomLeftRadius: "12px",
                                                      backgroundColor: item.color,
                                                    }}
                                                  />

          {/* Icon */}
          <Box sx={{ mb: 2, color: item.color }}>{item.icon}</Box>

          {/* Label */}
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            {item.label}
          </Typography>

          {/* Description */}
          <Typography
            variant="body2"
            sx={{ color: "#666", mb: 2, minHeight: "40px" }}
          >
            Click to view report
          </Typography>

          {/* Number Circle */}
          <Box
            sx={{
              width: 36,
              height: 36,
              borderRadius: "50%",
              backgroundColor: item.color,
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: "bold",
              fontSize: 14,
              mx: "auto",
            }}
          >
            {item.number}
          </Box>
        </Box>
      </motion.div>
    ))}
  </Box>
</CardContent>

      </Card>
    </Box>
  );
};

export default HRBPExpensesReportScreen;

